var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('highcharts',{key:_vm.key,ref:"chart",attrs:{"options":{..._vm.options}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }